import type { JobCompletionPhotoPolicy } from '../hooks/useAppSettings'
import { countJobPhotos, fetchTasksMissingRequiredPhotos } from '../api/jobWorkflow'

export async function jobMeetsPhotoPolicy(
  jobId: string,
  policy: JobCompletionPhotoPolicy
): Promise<{ ok: boolean; photoCount: number; message?: string }> {
  if (policy === 'off') {
    return { ok: true, photoCount: 0 }
  }
  const cameraOnly = policy === 'camera_required'
  const photoCount = await countJobPhotos(jobId, cameraOnly)
  if (photoCount > 0) return { ok: true, photoCount }
  return {
    ok: false,
    photoCount,
    message: cameraOnly
      ? 'This job requires at least one photo taken with the camera before completion.'
      : 'This job requires at least one photo before completion.',
  }
}

/** Global gallery policy + per-checklist-item photo_required tasks. */
export async function jobMeetsAllPhotoRequirements(
  jobId: string,
  policy: JobCompletionPhotoPolicy
): Promise<{ ok: boolean; message?: string; missingTaskLabels?: string[] }> {
  const global = await jobMeetsPhotoPolicy(jobId, policy)
  if (!global.ok) {
    return { ok: false, message: global.message }
  }

  const missing = await fetchTasksMissingRequiredPhotos(jobId)
  if (missing.length === 0) return { ok: true }

  const labels = missing.map((t) => t.label)
  const preview = labels.slice(0, 3).join('; ')
  const more = labels.length > 3 ? ` (+${labels.length - 3} more)` : ''
  return {
    ok: false,
    missingTaskLabels: labels,
    message: `Photo required for checklist item(s): ${preview}${more}`,
  }
}
